import { render } from "./ReceiveDelivery.vue?vue&type=template&id=6f947b6d&scoped=true"
import script from "./ReceiveDelivery.vue?vue&type=script&lang=js"
export * from "./ReceiveDelivery.vue?vue&type=script&lang=js"

import "./ReceiveDelivery.vue?vue&type=style&index=0&id=6f947b6d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f947b6d"]])

export default __exports__